// Icons - reusing from the original or importing standard equivalents
import PhoneIcon from "@mui/icons-material/Phone";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import MessageIcon from "@mui/icons-material/Message";
import NotificationsIcon from "@mui/icons-material/Notifications";
import CreateIcon from "@mui/icons-material/Create";
import BarChartIcon from "@mui/icons-material/BarChart";
import ArticleIcon from '@mui/icons-material/Article';
import VideocamIcon from '@mui/icons-material/Videocam'
export const serviceTypes = {
  base: {
    label: "Base",
    icon: ArticleIcon,
    acceptedFiles: ".json,.yaml,.yml",
    helperText: "Upload base configuration file (JSON or YAML format)",
  },
  call: {
    label: "Call",
    icon: PhoneIcon,
    acceptedFiles: ".json,.yaml,.yml",
    helperText: "Upload call configuration file",
  },
  calendar: {
    label: "Calendar",
    icon: CalendarTodayIcon,
    acceptedFiles: ".json,.yaml,.yml",
    helperText: "Upload calendar configuration file",
  },
  form: {
    label: "Form",
    icon: FormatAlignLeftIcon,
    acceptedFiles: ".json,.yaml,.yml",
    helperText: "Upload form configuration file",
  },
  message: {
    label: "Message",
    icon: MessageIcon,
    acceptedFiles: ".json,.yaml,.yml",
    helperText: "Upload message configuration file",
  },
  notification: {
    label: "Notification",
    icon: NotificationsIcon,
    acceptedFiles: ".json,.yaml,.yml",
    helperText: "Upload notification configuration file",
  },
  signature: {
    label: "Signature",
    icon: CreateIcon,
    acceptedFiles: ".json,.yaml,.yml",
    helperText: "Upload signature configuration file",
  },
  report: {
    label: "Report",
    icon: BarChartIcon,
    acceptedFiles: ".json,.yaml,.yml",
    helperText: "Upload report configuration file",
  },
  video: {
    label: "Video",
    icon: VideocamIcon,
    acceptedFiles: ".json,.yaml,.yml",
    helperText: "Upload report configuration file",
  },
};

export type ServiceKey = keyof typeof serviceTypes;